import { parseWistiaMediaId, parseWistiaStartTime } from "@videojs/media";
import { VideoCSSVars } from "@videojs/media/dom";
//#region src/source.ts
/**
* What a Wistia player is started with here, whatever Wistia's default or the Wistia app says; a source overrides it.
* Only the corner radius so far, squared because the skin is what rounds a media — see `wistiaPlayerStyle`.
* `roundedPlayer` is the one to set: the three `*BorderRadius` options derive from it.
*
* @internal
*/
const wistiaPlayerDefaultOptions = { roundedPlayer: 0 };
/**
* The style a Wistia player is given: the skin's corners, and no pointer events without chrome.
*
* `borderRadius` reads the same custom property a `<video>` does, and `overflow` goes with it — a `<video>` is replaced
* content that the radius alone clips, where Wistia paints into children the box has to clip too. `pointerEvents` is
* off for a chromeless player because the skin over it is what the viewer is clicking; left interactive it swallows
* those clicks and answers them with chrome of its own. The iframe embeds do the same through a
* `:host(:not([controls]))` rule in a template they own, which a player that brings its own element has no equivalent
* of.
*
* @internal
*/
function wistiaPlayerStyle(controls) {
	return {
		borderRadius: `var(${VideoCSSVars.borderRadius})`,
		overflow: "hidden",
		pointerEvents: controls ? "auto" : "none"
	};
}
/**
* The eight control-bar switches `controls` drives as a group, since Wistia has no single chromeless flag.
* `playBarControl` doubles as the one the group is read back from.
*
* @internal
*/
function wistiaControlProps(controls) {
	return {
		bigPlayButton: controls,
		controlsVisibleOnLoad: controls,
		fullscreenControl: controls,
		playBarControl: controls,
		playPauseControl: controls,
		playPauseNotifier: controls,
		settingsControl: controls,
		volumeControl: controls
	};
}
//#endregion
export { parseWistiaMediaId, parseWistiaStartTime, wistiaControlProps, wistiaPlayerDefaultOptions, wistiaPlayerStyle };
